import React from 'react';
import { useStore } from '../../store';

const PopUp = () => {
    const { state: { popup: { show = false, component: Component } } } = useStore();

    return (
        show ? (
            <div className="popUpContainer">
                <div className="popUp">
                    {Component}
                </div>
                <div id="loaderBackgroundOverlay" className="backgroundOverlay" />
            </div>
        ) : null
    );
};

export default PopUp;
